import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { ContextMenuService, ContextMenuComponent } from '@perfectmemory/ngx-contextmenu';
import {Consumer} from '@emm/core/models/consumer.model';
import {MenuFiltersFacadeService} from "@emm/menu/services/menu-filters-facade.service";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-consumer',
    styleUrls: ['./consumer.component.scss'],
    templateUrl: './consumer.component.html',
    standalone: false
})
export class ConsumerComponent implements OnInit {

    @Input() consumers: Consumer[];
    @Output() consumerSelected = new EventEmitter<Consumer>();

    selected: Consumer;
    selectedConsumer$ = this.filtersFacade.selectedConsumer$;

    constructor(private contextMenuService: ContextMenuService<any>, private filtersFacade: MenuFiltersFacadeService) {}

    ngOnInit(): void {}

    onConsumerSelected(selected: Consumer): void {
        this.consumerSelected.emit(selected);
        this.selected = selected;
    }
}
